import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, take, tap } from 'rxjs/operators';
import { Guid } from 'guid-typescript';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  defaultGuidValue = Guid.EMPTY as unknown as Guid;
  constructor(
    public oidcSecurityService: OidcSecurityService,
    private cookieService: CookieService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isIdentityServerRequest(request.url)) {
      return next.handle(request);
    }

    let tokenValue = '';
    this.oidcSecurityService
      .getAccessToken()
      .pipe(take(1))
      .subscribe((token) => {
        tokenValue = token;
      });

    const token = this.cookieService.get('newToken') || tokenValue;
    const authToken = 'Bearer ' + token;
    const apiReq = request.clone({
      setHeaders: {
        Authorization: authToken,
        'Access-Control-Allow-Origin': '*',
        userid: this.cookieService.get('userid'),
        businessid: this.cookieService.get('businessid'),
        CompanyId:
          this.cookieService.get('companyid') !== 'undefined' &&
          this.cookieService.get('companyid') !== 'null'
            ? this.cookieService.get('companyid')
            : this.defaultGuidValue.toString(),
      },
    });

    return next.handle(apiReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.setUserDetails(event);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.oidcSecurityService.logoff().subscribe({
            next: () => {
              localStorage.clear();
              sessionStorage.clear();
              this.cookieService.deleteAll('/');
            },
            error: () => {
              localStorage.clear();
              sessionStorage.clear();
              this.cookieService.deleteAll('/');
              this.oidcSecurityService.authorize();
            },
          });
        }

        return throwError(error);
      })
    );
  }

  private setUserDetails(event: HttpResponse<any>): void {
    const userId = event.headers.get('userid');
    const businessId = event.headers.get('businessid') || '';
    const themecolor = event.headers.get('themecolor') || '';
    const authorizedRole = event.headers.get('authorizedRole') || '';

    this.cookieService.set('isLoggedin', userId ? 'true' : 'false');

    if (userId) {
      const isAdmin = authorizedRole !== '4' ? 'true' : 'false';
      const isOwner = authorizedRole === '1' ? 'true' : 'false';
      const isRegularUser = authorizedRole === '4' ? 'true' : 'false';
      const isManager = authorizedRole === '3' ? 'true' : 'false';

      this.cookieService.set('authorizedRole', authorizedRole);
      this.cookieService.set('userid', userId);
      this.cookieService.set('isAdmin', isAdmin);
      this.cookieService.set('isOwner', isOwner);
      this.cookieService.set('isRegularUser', isRegularUser);
      this.cookieService.set('isManager', isManager);
    }

    if (businessId) {
      this.cookieService.set('businessid', businessId);
    }

    if (themecolor) {
      this.cookieService.set('themecolor', themecolor);
    }
  }

  private isIdentityServerRequest(url: string): boolean {
    return (
      url.includes('/connect/') ||
      url.includes('/.well-known/') ||
      (url.includes('account.') && url.includes('capium.co.uk'))
    );
  }
}
